import { SIDEBAR } from '../actions/types';

const initialState = {
  hiddenItemsId: []
};

export default function (state = initialState, action) {
  switch (action.type) {

    case SIDEBAR.SET_HIDDEN_ITEMS:
      return {
        ...state,
        hiddenItemsId: action.payload
      };

    default:
      return state;
  }
};